// test318
(318 && 0);
